module.exports = __webpack_public_path__ + "img/lightqiao.fe60db13.png";